module.exports = __webpack_public_path__ + "static/noun-web-developer-1873915-f1501b41daac86eb2798f1bec1867402.svg";